module.exports = __webpack_public_path__ + "img/create-filter-mobile.c0a8bdc2.png";